import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Guard use for protect routes from without logging users

export const RequireAuth = ({ children }) => {
  const userToken = useSelector((state) => state?.user?.user);
  if (!userToken?.token) {
    return <Navigate to="/auth/login" />;
  }
  return children;
};
